export default __webpack_public_path__ + "static/media/8.56ff7988.webp";